import { useIntl } from '@leagueplatform/locales';
import { TranslationObject } from '@web-config-app/core';

export const getLabelText = (
  formatMessage: ReturnType<typeof useIntl>['formatMessage'],
  label?: TranslationObject,
) => {
  if (!label) return '';
  if (label.key) return formatMessage({ id: label.key }, label.values);
  return label.text ?? '';
};
